<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header">Login</div>

          <div class="card-body">
            <form class="form" @submit.prevent="login">

              <div v-if="apiResponse && apiResponse.errors && Object.keys(apiResponse.errors).length" class="alert alert-danger">
                <ul class="mb-0">
                  <template v-for="(value) in Object.values(apiResponse.errors).flat()">
                    <li>{{ value }}</li>
                  </template>
                </ul>
              </div>

              <div class="form-group row">
                <label for="name" class="col-md-4 col-form-label text-md-right">ログインID</label>

                <div class="col-md-6">
                  <input v-model="loginForm.name" id="name" type="text" class="form-control" name="name" required autocomplete="name" autofocus>
                </div>
              </div>

              <div class="form-group row">
                <label for="password" class="col-md-4 col-form-label text-md-right">Password</label>

                <div class="col-md-6">
                  <input v-model="loginForm.password" id="password" type="password" class="form-control" name="password" required autocomplete="current-password">
                </div>
              </div>

              <div class="form-group row mb-0">
                <div class="col-md-8 offset-md-4">
                  <button dusk="login" type="submit" class="btn btn-success">
                    ログイン
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loginForm: {
        name: '',
        password: ''
      },
    };
  },
  computed: {
    apiStatus() {
      return this.$store.state.auth.apiStatus;
    },
    apiResponse() {
      return this.$store.state.auth.apiResponse;
    }
  },
  methods: {
    async login() {
      // authストアのloginアクションを呼び出す
      await this.$store.dispatch('auth/login', this.loginForm);

      // トップページに移動
      if (this.apiStatus) {
        this.$router.push(this.$route.query.redirect ?? '.');
      }
    }
  }
}
</script>

